// JS for your graphic
import pym from "pym.js";
import * as d3 from "d3";
import csv from "../data/data.csv";
import first from "../data/first_lockdown.csv"
import second from "../data/second_lockdown.csv"

const draw = () => {
  // step 1: access data
  var parseTime = d3.timeParse("%m/%d/%Y");
  var formatMonth = d3.timeFormat("%b");
  var formatDay = d3.timeFormat("%d");
  const shortMonth = d3.timeFormat("%b.");
  const fullMonth = d3.timeFormat("%B");

  // step 2: create chart dimensions
  const margin = { top: 10, left: 40, right: 40, bottom: 20 };
  const width = window.innerWidth - margin.right - margin.left;
  const height = 300;

  // step 3: draw canvas
  const svg = d3
    .select("#viz")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom);
  const g = svg
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  d3.csv(first).then((data1) => {
    var data = data1.map((d) => ({
      date: parseTime(d.week),
      uniCases: +d.university,
      countyCases: +d.county - +d.university,
    }));
    const yMax = d3.max(data, (d) => d.countyCases + d.uniCases);

    // List of groups = species here = value of the first column called group -> I show them on the X axis
    // step 4: create scales
    const xDomain = data.map((d) => d.date);
    var x = d3
      .scaleTime()
      .domain([xDomain[0], xDomain[xDomain.length - 1]])
      .range([0, width]);
    // var groups = d3.map(data, function(d){return(d.group)}).keys()
    var groups = ["uniCases", "countyCases"]
    g.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x).tickFormat(function (d, i, f) {
        var day = formatDay(d);
        var month = fullMonth(d);
        // X AXIS TICK TEXT CONFIG
        var tickLen = f.length - 1;
        var halfLen = Math.floor(tickLen / 2);

        let tick = "";
        tick = `${shortMonth(d)} ${day}`;
        if (+day < 10) {
          tick = tick.replace("0", "");
        }
        return tick;
      }));

    // Add Y axis
    var y = d3.scaleLinear()
      .domain([0, yMax])
      .range([ height, 0 ]);
    g.append("g")
      .attr("class", "y axis")
      .call(d3.axisLeft(y));


    // color palette = one color per subgroup
    var color = d3.scaleOrdinal()
      .domain(groups)
      .range(['#A05195','#F95D6A'])

    //stack the data? --> stack per subgroup
    var stackedData = d3.stack()
      .keys(groups)
      (data)

    // Show the bars
    g.append("g")
      .selectAll("g")
      // Enter in the stack data = loop key per key = group per group
      .data(stackedData)
      .enter().append("g")
        .attr("fill", function(d) { 
          return color(d.key); })
        .selectAll("rect")
        // enter a second time = loop subgroup per subgroup to add all rectangles
        .data(function(d) { 
          return d; })
        .enter().append("rect")
          .attr("x", function(d) { return x(d.data.date); })
          .attr("y", function(d) { return y(d[1]); })
          .attr("height", function(d) { return y(d[0]) - y(d[1]); })
          .attr("width",20)
          .raise()
    d3.selectAll(".y.axis line")
      .attr("x2", width + 10)
      .attr("opacity", 0.2);
    d3.selectAll(".y").lower();
  // step 6: draw peripherals
  // step 7: set up interactions
  });
};

const resize = () => {};

window.onload = function () {
  const pymChild = new pym.Child({ renderCallback: resize, polling: 500 });
  draw();
  pymChild.sendHeight();
};
